var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.imageUrlList),function(url,index){return _c('el-image',{key:index,staticStyle:{"width":"100px","height":"100px"},attrs:{"src":url+'?x-oss-process=image/resize,l_150',"preview-src-list":_vm.imageUrlList}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }